import { useTranslation } from "next-i18next";
import Image from "next/image";

import Advantage from "../../components/Advantage";
import CustomHead from "../../components/CustomHead";
import Discuss from "../../components/Discuss";
import Map from "../../components/Map";
import MaxWidth from "../../components/MaxWidth";
import PageDescription from "../../components/PageDescription";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import SloganLink from "../../components/SloganLink";

import styles from "./About.module.scss";

import AtomIcon from "../../public/imgs/icons/atom_icon.svg?url";
import GroupIcon from "../../public/imgs/icons/group.svg?url";
import SquareIcon from "../../public/imgs/icons/square_icon.svg?url";
import LogoItv from "../../public/imgs/clients/logo-itv.png";
import LogoIss from "../../public/imgs/clients/logo-iss.png";
import LogoSigur from "../../public/imgs/clients/logo-sigur.png";
import LogoBolid from "../../public/imgs/clients/logo-bolid.png";
import LogoNbki from "../../public/imgs/clients/logo-nbki.png";
import LogoRecfaces from "../../public/imgs/clients/logo-recfaces.png";
import LogoBit from "../../public/imgs/clients/logo-bit.png";
import GridContainer from "../../components/GridContainer/GridContainer";
import { useRouter } from "next/router";

export default function About() {
  const { t, i18n } = useTranslation(["aboutPage", "meta"]);
  const { language } = i18n;
  const router = useRouter();

  const handleClick: (e: any, href: string) => void = (e, href) => {
    if (e.ctrlKey || e.metaKey) {
      window.open(href, "_blank");
    } else {
      router.push(href);
    }
  };
  return (
    <PageWrapper>
      <CustomHead title={t("common:about_us")!} desc={t("meta:about_page")!} />
      <PageDescription
        title={t("common:about_us")}
        description={
          <span>
            {t("specialization")}
            <br />
            <br />
            {t("solutions")}
          </span>
        }
      />
      <SloganLink
        text={
          <span>
            {t("mainPage:about_1")}
            <br />
            {t("mainPage:about_2")}
            <br />
            {t("mainPage:about_3")}
          </span>
        }
        btnTitle={t("common:solutions")}
        handleClick={(e) => handleClick(e, "/solution")}
      />
      <MaxWidth addclasses={[styles["advantages"]]} color="blue">
        <Advantage
          icon={AtomIcon}
          title={t("scientific_approach")}
          description={t("scientific_approach_desc")}
          addclasses={[styles["advantage-card"]]}
        />
        <Advantage
          icon={SquareIcon}
          title={t("solving_problems")}
          description={t("solving_problems_desc")}
          addclasses={[styles["advantage-card"]]}
        />
        <Advantage
          icon={GroupIcon}
          title={t("ethic_approach")}
          description={
            <span>
              {t("ethic_approach_desc_p1")}
              <br />
              <br />
              {t("ethic_approach_desc_p2")}
            </span>
          }
          addclasses={[styles["advantage-card"]]}
        />
      </MaxWidth>
      <Map />
      <MaxWidth>
        <GridContainer addclasses={[styles["companies"]]}>
          <h3>{t("improving_skills")}</h3>
          <div className={styles["companies-list"]}>
            <Image src={LogoItv} alt="itv" quality={100} />
            <Image src={LogoIss} alt="iss" quality={100} />
            <Image src={LogoSigur} alt="sigur" quality={100} />
            <Image src={LogoBolid} alt="bolid" quality={100} />
            <Image src={LogoNbki} alt="NBKI" quality={100} />
            {language && !language.includes("en") && (
              <Image src={LogoRecfaces} alt="recfaces" quality={100} />
            )}
            <Image src={LogoBit} alt="BIT" quality={100} />
          </div>
        </GridContainer>
      </MaxWidth>
      <Discuss />
    </PageWrapper>
  );
}
